import { render, staticRenderFns } from "./myUpload.vue?vue&type=template&id=aaed389a&scoped=true"
import script from "./myUpload.vue?vue&type=script&lang=js"
export * from "./myUpload.vue?vue&type=script&lang=js"
import style0 from "./myUpload.vue?vue&type=style&index=0&id=aaed389a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaed389a",
  null
  
)

export default component.exports